import { render } from "./OurContent.vue?vue&type=template&id=450faf2c&ts=true"
import script from "./OurContent.vue?vue&type=script&lang=ts"
export * from "./OurContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__